export default __webpack_public_path__ + "static/media/announcements.459f1cdd.svg";